import React, { Suspense, lazy  } from "react";
import { Route, Routes} from "react-router-dom";
import LoadingSpinner, { SpinnerSize } from "../components/general/LoadingSpinner/LoadingSpinner";
import HandleOAuthCallback from "../page/HandleOAuthCallback";

/* Components */
const ShortcodeRoutes = lazy(() => import("./ShortcodeRoutes")) ;
const OrganisationLoginScreen = lazy(() => import("../page/LoginRegister/OrganisationLogin/OrganisationLoginScreen"));
const Redirector = lazy(() => import( "../components/general/Redirector"));

export const AppRoutes = () => {
  return (
    <Suspense fallback={<div className="page-loading-spinner"><LoadingSpinner spinnerSize={SpinnerSize.LARGE} /> </div>}>
      <Routes>
          <Route path=":shortcode/callbackinternal" element={<HandleOAuthCallback />} />
          <Route path=":shortcode/*" element={<ShortcodeRoutes />} />
          <Route path="organisation" element={<OrganisationLoginScreen />} />
          <Route path="*" element={<Redirector />} />
      </Routes>
    </Suspense>
  );
};
